import Cookies from 'js-cookie';
import Decode from 'jwt-decode';

import { GIGYA_PUBLIC_KEY } from '@constants';

const isBrowser = typeof window !== `undefined`;
export const retrieveAccessToken = () => {
  if (!isBrowser) return;
  return Cookies.get('access_token');
};

export const setAccessToken = token => {
  if (!isBrowser) return;

  Cookies.set('access_token', token);
};

export const removeAccessToken = () => {
  if (!isBrowser) return;

  Cookies.remove('access_token');
  Cookies.remove(`glt_${GIGYA_PUBLIC_KEY}`);
};

export const validateToken = token => {
  try {
    if (!isBrowser) return;

    const decoded = Decode(token);

    return Date.now() < decoded.exp * 1000;
  } catch (err) {
    return false;
  }
};
